export { default as CourseChangeButton } from './change/CourseChangeButton.vue';
export { default as CourseChangeDialog } from './change/CourseChangeDialog.vue';
